module.exports = __webpack_public_path__ + "img/mg-kid.a95edbe3.png";